import { Injectable } from '@angular/core';
import { SwUpdate, SwPush, UpdateAvailableEvent } from '@angular/service-worker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { interval, Observable } from 'rxjs';
import { IAppState } from '../../../store/state/app.state';
import { GetMessage } from '../../../store/actions/message.actions';
import { select, Store } from '@ngrx/store';
import { IMessage } from '../../../models/message.interface';
import { ISco } from '../../../models/sco.interface';
import { selectSco } from '../../../store/selectors/sco.selectors';
import { selectSession } from '../../../store/selectors/page.selectors';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggerService } from '../../log4ts/logger.service';

/**
 * Service to manage service worker
 */
@Injectable({
  providedIn: 'root',
})
export class UpdateService {
  /**
   * Vapid key to push notification
   */
  readonly VAPID_PUBLIC_KEY =
    'BP_kK8ybQ8fEuk5XTN-QK19HmsFGFw5FKvgFttWMauqmpdlg1RViN4JgwzpMdzVL1gfTDLllrn4_cRvjf5V5q_E';

  scoObs$ = this._store.pipe(select(selectSco));
  session$ = this._store.pipe(select(selectSession));
  public scoN: number;
  cart = false;
  sId = '';
  /**
   * Constructor service
   * @param updates class to check update
   * @param swPush class to send push notification
   * @param snackBar class to show snack alert
   */
  constructor(
    public updates: SwUpdate,
    public swPush: SwPush,
    public snackBar: MatSnackBar,
    private _store: Store<IAppState>,
    private route: ActivatedRoute,
    private console: LoggerService
  ) {
    this.route.queryParams.subscribe((queryParams) => {
      if (queryParams.sID && this.sId === '') {
        this.sId = '&sID=' + queryParams.sID;
      }
    });
    this.session$.subscribe((x) => {
      if (x && this.sId === '') {
        this.sId = '&sID=' + x;
      }
    });
    this.scoN = 0;
    // If updates are enabled
    if (this.updates.isEnabled) {
      const subSco = this.scoObs$.subscribe((x) => {
        if (x) {
          this.scoN = x.length;
        }
        if (!this.scoN && this.cart) {
          subSco.unsubscribe();
          window.location.assign(window.location.href + this.sId);
        }
      });
      // poll the service worker to check for updates
      interval(30000).subscribe(() => {
        this.updates.checkForUpdate();
      });
    }
  }

  /**
   * Function call to subscribe notification
   */
  public subscribeNotification() {
    this.swPush
      .requestSubscription({
        serverPublicKey: this.VAPID_PUBLIC_KEY,
      })
      .then((sub) => this.console.log(sub.toJSON()))
      .catch((err) => this.console.error('Could not subscribe to notifications', err));
  }

  /**
   * Called from app.components.ts constructor to check update
   */
  public checkForUpdates() {
    if (this.updates.isEnabled) {
      this.updates.available.subscribe((event) => {
        this.console.log('current version is', event.current);
        this.console.log('available version is', event.available);
        this.promptUser(event);
      });
      this.updates.activated.subscribe((event) => {
        this.console.log('old version was', event.previous);
        this.console.log('new version is', event.current);
      });
    }
  }

  /**
   * If there is an update, promt the user
   * @param e event update available
   */
  private promptUser(e: UpdateAvailableEvent): void {
    if (e.available) {
      if (this.scoN === 0) {
        window.location.assign(window.location.href + this.sId);
      } else {
        this.cart = true;
      }
      /* const mes: IMessage = {
        message: String(e.available),
        type: 'update'
      };
      this._store.dispatch(new GetMessage(mes)); */
    }
  }
}
